Controller.$inject = ['$timeout'];

function Controller($timeout) {
    const self = this;
    self.showLegend = false;
    self.inputFocused = false;

    self.$postLink = () => {
        if (self.labelVariant === 'outlined' && self.ngModel) {
            self.showLegend = true;
        }
    };

    self.handleFocus = () => {
        if (self.labelVariant === 'outlined') {
            self.showLegend = true;
            self.inputFocused = true;
        }
    };

    self.handleBlur = () => {
        if (!self.ngModel) {
            self.showLegend = false;
        }
        self.inputFocused = false;
    };

    self.handleChange = ($event) => {
        $timeout(() => {
            self.onChange({$event});
        });
    };
}

export function HuiInputPassword() {
    return {
        restrict: 'E',
        scope: true,
        bindToController: {
            ngModel: '=',
            labelVariant: '@',
            iconPosition: '@',
            disabled: '<',
            hName: '@',
            hasError: '<',
            placeholder: '@',
            onChange: '&',
            fullWidth: '<'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: {
            label: '?huiInputLabel',
            icon: '?huiInputIcon'
        },
        template: ($element, $attrs) => {
            return `
              <hui-input-base
                label-variant="{{$huiCtrl.labelVariant}}"
                icon-position="{{$huiCtrl.iconPosition || 'start'}}"
                has-error="$huiCtrl.hasError"
                show-legend="$huiCtrl.showLegend"
                input-focused="$huiCtrl.inputFocused"
                model-value="$huiCtrl.ngModel"
                disabled="$huiCtrl.disabled"
                full-width="$huiCtrl.fullWidth">
                <hui-input-base-label ng-transclude ng-transclude-slot="label"></hui-input-base-label>
                <hui-input-base-icon ng-transclude ng-transclude-slot="icon"></hui-input-base-icon>
                    <input type="password"
                           ng-model="$huiCtrl.ngModel"
                           ng-disabled="$huiCtrl.disabled"
                           placeholder="{{$huiCtrl.labelVariant !== 'outlined' ? $huiCtrl.placeholder : ''}}"
                           name="{{$huiCtrl.hName}}"
                           class="hui-base-input"
                           ng-focus="$huiCtrl.handleFocus()"
                           ng-blur="$huiCtrl.handleBlur()"
                           ng-change="$huiCtrl.handleChange($event)"/>
              </hui-input-base>
             `;
        }
    }
}